"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import SSRIcon from "@ingka/ssr-icon";
import cx from "classnames";
const Toggle = (props) => {
  const {
    className,
    prefix = "",
    buttons,
    iconOnly = false,
    onClick = () => void 0,
    fluid = false,
    activeIndex = 0,
    ...others
  } = props;
  function renderToggleButtons() {
    return buttons.map((buttonProps, index) => {
      if (!buttonProps) {
        return null;
      }
      const { ssrIcon, text, disabled, ...other } = buttonProps;
      const isActive = activeIndex === index;
      const baseClass = `${prefix}toggle__button`;
      const cssStyles = cx(
        baseClass,
        iconOnly && ssrIcon && `${baseClass}--icon-only`,
        isActive && `${baseClass}--active`,
        fluid && `${baseClass}--fluid`
      );
      return /* @__PURE__ */ jsxs(
        "button",
        {
          disabled: disabled && !isActive,
          className: cssStyles,
          "aria-pressed": isActive ? "true" : "false",
          onClick: (e) => onClick(e, index),
          ...other,
          children: [
            iconOnly && ssrIcon !== void 0 && ssrIcon && /* @__PURE__ */ jsx(SSRIcon, { prefix, paths: ssrIcon }),
            text && /* @__PURE__ */ jsx("span", { className: `${prefix}toggle__button-label`, children: text })
          ]
        },
        index
      );
    });
  }
  const classes = cx(`${prefix}toggle`, className);
  return /* @__PURE__ */ jsx("div", { className: classes, ...others, children: buttons && renderToggleButtons() });
};
var Toggle_default = Toggle;
export {
  Toggle_default as default
};
